<template>
    <div class="clearfix" id="case-box">
        <nav-header></nav-header>
        <div class="case-select-box">
            <div :class="[type == 0? 'case-select-all' : '']" @click="typeClick(0)">
                <p>全部</p>
                <p>ALL</p>
            </div>
            <div :class="['case-select-theme',type == 1? 'case-theme-selected' : '']" @click="typeClick(1)">
                <p>主题空间</p>
                <p>THEME SPACE</p>
            </div>
            <div :class="['case-select-brand',type == 2? 'case-brand-selected' : '']" @click="typeClick(2)">
                <p>品牌形象</p>
                <p>BRAND IMADE</p>
            </div>
            <div :class="['case-select-imade',type == 3? 'case-imade-selected' : '']" @click="typeClick(3)">
                <p>样本画册</p>
                <p>BRAND IMADE</p>
            </div>
        </div>
        <div class="home-case-box" v-if="caseData.length>0">
            <div class="row mx-0" v-for="(item,key) in caseData" :key="key">
                <div class="col-4 col-lg-4 card border-0 px-0 py-0" v-for="(value,index) in item" :key="index" @click="caseDetails(value.id)">
                    <img :src="value.cover"/>
                    <div class="card-body pb-0">
                        <h4 class="mb-0">{{value.title}}</h4>
                        <p>项目内容：{{value.svccontent}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="none-box">
            暂无案例数据
        </div>
        <Footer></Footer>
    </div>
</template>
<script>
import NavHeader from '@/components/navHeader.vue'
import Footer from "@/components/footer.vue";
import { selectCases } from '@/api/cases';
export default {
    name: "Case",
    components: {
        NavHeader,
        Footer
    },
    data() {
        return {
            type: 0,
            //案例展示
            caseData: [],
        }
    },
    created() {
        this.paramsUrl();
    },
    methods: {
        /**
         * @desc 点击进案例详情
         */
        caseDetails(id) {
            this.$router.push({
                path: '/caseDetails',
                query: {
                    id
                }
            })
        },
        /**
         * @desc type类型点击
         */
        typeClick(type) {
            this.$router.push({
                path: "/case",
                query: {
                    type
                }
            })
        },
        /**
         * @desc 检测页面是否带了type值初始化type
         */
        paramsUrl() {
            let query = this.$route.query;

            if (typeof query.type != 'undefined' && query.type != '0') {
                this.type = query.type;
            } else {
                this.type = 0;
            }
            this.selectCases();
        },
        /**
         * @desc 获取案例数据
         */
        selectCases() {
            let params = {};

            if(this.type != 0) {
                params.type = this.type;
            }

            selectCases(params).then(res => {
                let array = [];
                res.data.forEach(item => {
                    item.cover = '/express_api' + item.cover;
                    if(array.length == 0) {
                        array.push([item]);
                    } else {
                        let length = array.length - 1;

                        if (array[length].length != 3) {
                            array[length].push(item);
                        } else {
                            array.push([item]);
                        }
                    }
                })
                this.caseData = array;
            })
        },
    },
    mounted() {
        
    }
}
</script>
<style lang="scss" scoped>
#case-box {
    margin-top: 80px;
    .home-case-box {
        // width: 1770px;
        margin: 0 75px 195px;
        min-height: 600px;

        .card {
            position: relative;
            overflow: hidden;
            cursor: pointer;
            border-radius: 0;

            img {
                height: 390px;
                transition: all 0.2s linear;
            }
            .card-body {
                // display: none;
                transition: all 0.2s linear;
                position: absolute;
                bottom: 0;
                background: rgba(0,0,0,.7);
                width: 100%;
                color: #fff;
                line-height: 24px;
                box-sizing: border-box;
                padding-left: 30px;
                text-align: left;
                transition: all 0.2s linear;
                transform: rotateY(90deg);

                h4 {
                    font-size: 16px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                p {
                    font-size: 12px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }

            &:hover {
                img {
                    transform: scale(1.2);
                }
                .card-body {
                    // display: block;
                    transform: rotate(0);
                }
            }
        }
    }

    .case-select-box {
        width: 1200px;
        height: 50px;
        padding: 75px 0 50px;
        margin: 0 auto;
        box-sizing: initial;
        display: flex;
        justify-content: space-around;

        div {
            cursor: pointer;
            background: url('../../public/images/case/icon1.png') left center no-repeat;
            padding-left: 60px;

            &.case-select-theme {
                background-image: url('../../public/images/case/icon2.png');
            }

            &.case-select-brand {
                background-image: url('../../public/images/case/icon3.png');
            }

            &.case-select-imade {
                background-image: url('../../public/images/case/icon4.png');
            }

            &.case-select-all,
            &:hover {
                background-image: url('../../public/images/case/icon1_hover.png');
            }
            &.case-theme-selected,
            &.case-select-theme:hover {
                background-image: url('../../public/images/case/icon_hover.png');
            }

            &.case-brand-selected,
            &.case-select-brand:hover {
                background-image: url('../../public/images/case/icon3_hover.png');
            }

            &.case-imade-selected,
            &.case-select-imade:hover {
                background-image: url('../../public/images/case/icon4_hover.png');
            }
        }

        p {
            margin: 0;
            font-size: 18px;
            color: #333333;
            text-align: left;

            &:last-child {
                font-size: 12px;
                color: #999999;
            }
        }
    }

    .none-box {
        height: 500px;
        line-height: 500px;
    }
}
@media screen and (max-width: 1260px){
    #case-box {
        .case-select-box  {
            width: auto;
            margin: 0 20px;
        }
    }
}
</style>